import React from 'react';
import PropTypes from 'prop-types';

import Sidebar from 'pages/Modules/Sidebar/Sidebar';
import Appbar from 'pages/Modules/Appbar/Appbar';

const Main = ({ children }) => {
  return (
    <div className="h-screen bg-default-background">
      <Appbar />
      <div className="flex body-wrapper pt-5 bg-default-background">
        <Sidebar />
        <section className="px-4 w-full h-full overflow-y-auto overflow-x-hidden bg-default-background">
          {children}
        </section>
      </div>
    </div>
  );
};

export default Main;

Main.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
